import React from 'react';
import HomePageView from "./home-page-view";

const HomePage:React.FC = () =>{
    return <HomePageView/>
}

export default HomePage ;